export default "__VITE_ASSET__Bg6$By3Z__"